module.exports = __webpack_public_path__ + "favicon.fd73a6eb.ico";


//////////////////
// WEBPACK FOOTER
// ./client/components/favicon.ico
// module id = 664
// module chunks = 0